module.exports = {
  STRING: 'string',
  TARGET_SELECTOR: 'target_selector',
};
